export const truncateString = (str: string, num: number): string => {
  if (!str) return '';
  if (str.length <= num) return str;
  return str.slice(0, num) + '...';
};
